import { render, staticRenderFns } from "./AddProjectSimple.vue?vue&type=template&id=0192d030&scoped=true&"
import script from "./AddProjectSimple.vue?vue&type=script&lang=js&"
export * from "./AddProjectSimple.vue?vue&type=script&lang=js&"
import style0 from "./AddProjectSimple.vue?vue&type=style&index=0&id=0192d030&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0192d030",
  null
  
)

export default component.exports